import { useCallback } from 'react';

import { useLocale } from 'hooks/useLocale';

type TranslatedTextFragment = {
  en?: string | null;
  ar?: string | null;
};

export const useTranslatedText = () => {
  const { locale } = useLocale();
  return useCallback(
    (text?: TranslatedTextFragment | null) => text?.[locale] ?? '',
    [locale],
  );
};
